// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfbJ7tI-qEC3LL4-bm3NQsgyy_IP6MI3s",
  authDomain: "willtowealth-e0032.firebaseapp.com",
  projectId: "willtowealth-e0032",
  storageBucket: "willtowealth-e0032.firebasestorage.app",
  messagingSenderId: "542919081097",
  appId: "1:542919081097:web:5f597ad37f9a2b6c559a58",
  measurementId: "G-VF26LWGMYK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);